/** A Security link that leads nowhere: the page list instead of a dead end. */
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import HelpShell from '@/components/help/HelpShell';
import SecurityIcon from '@/components/security/SecurityIcon';
import { SECURITY_CENTER, SECURITY_BASE_PATH } from '@/content/security';

export default function SecurityNotFound() {
  return (
    <HelpShell showSearch={false} homeLabel="Security" homeHref={SECURITY_BASE_PATH}>
      <Helmet>
        <title>Page not found | Defera Security</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="mx-auto max-w-2xl px-4 sm:px-6 py-24">
        <h1 className="text-center text-[30px] font-semibold text-white">We couldn’t find that page</h1>
        <p className="mt-3 text-center text-[16px] text-white/65">
          It may have moved. Here’s everything in{' '}
          <Link to={SECURITY_BASE_PATH} className="text-[#AAB4D6] underline decoration-white/25 underline-offset-2 hover:text-white">Security</Link>.
        </p>
        <ul className="mt-8 space-y-1">
          {SECURITY_CENTER.pages.map((p) => (
            <li key={p.slug}>
              <Link to={p.path} className="flex items-center gap-3 rounded-xl px-3 py-3 text-[15.5px] text-white/85 hover:bg-white/[0.05] hover:text-white">
                <SecurityIcon name={p.icon} className="h-[18px] w-[18px] text-[#C9D0EA]" />
                {p.title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </HelpShell>
  );
}
